import type { OnInit } from '@angular/core';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { GiveGetService } from '@freelancer/give-get';
import { Seo } from '@freelancer/seo';
import type { PictureBackgroundImageStyles } from '@freelancer/ui/picture';
import {
  PictureBgImageObjectFit,
  PictureBgImagePosition,
  PictureLoadMethod,
} from '@freelancer/ui/picture';

@Component({
  standalone: false,
  selector: 'app-signup-page',
  template: `
    <div
      class="SignupPage"
      flTrackingSection="FreelancerSignupPage"
    >
      <div class="SignupPageContainer">
        <app-signup (switchToLogin)="redirectToLogin()"></app-signup>
      </div>
      <div class="PictureContainer mobile:hide">
        <fl-picture
          [src]="'job-post/redesign/bird.jpg'"
          [backgroundStyles]="backgroundStyles"
          [isBackgroundImage]="true"
        ></fl-picture>
        <fl-picture
          class="PictureContainer-textImage"
          [loadMethod]="PictureLoadMethod.PRELOAD"
          [src]="'job-post/redesign/make-it-real.png'"
        ></fl-picture>
      </div>
    </div>
  `,
  styleUrls: ['./signup-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignupPageComponent implements OnInit {
  PictureLoadMethod = PictureLoadMethod;

  backgroundStyles: PictureBackgroundImageStyles = {
    position: PictureBgImagePosition.LEFT_CENTER,
    objectFit: PictureBgImageObjectFit.COVER,
  };

  constructor(
    private giveGetService: GiveGetService,
    private router: Router,
    private seo: Seo,
  ) {}

  ngOnInit(): void {
    this.seo.setPageTags({
      title: 'User Signup',
      description: `Sign up to post projects, outsource work or find jobs on the World’s Largest Outsourcing Marketplace Freelancer.`,
    });
    this.giveGetService.setReferralTokenCookie();
  }

  redirectToLogin(): void {
    this.router.navigate(['login'], { queryParamsHandling: 'merge' });
  }
}
